/** Canvas Global Brand Breath — one-per-runtime session gate
 * (VISTOERA_CANVAS_GLOBAL_BRAND_BREATH_V1 §25/§26).
 *
 * Deliberately an in-memory module-level flag, NOT `localStorage` — the
 * product requirement is "one Brand Breath per frontend runtime" (a hard
 * browser refresh resets it; navigating between pages/Canvas projects
 * within the same SPA session does not). A module singleton is the
 * simplest thing that is true for as long as this JS module stays loaded,
 * which is exactly the lifetime of one "frontend runtime" (§25/§26).
 *
 * Exported as a function (not the raw boolean) so callers can't
 * accidentally read it without also consuming it, and so tests can reset
 * it via `__resetCanvasGlobalBrandBreathSessionForTests`. */

let shown = false

/** Returns `true` exactly once per module lifetime (i.e. once per hard
 * page refresh) — every subsequent call, from any Canvas project, returns
 * `false`. */
export function consumeCanvasGlobalBrandBreathEntitlement(): boolean {
  if (shown) return false
  shown = true
  return true
}

/** Test-only escape hatch — never call from product code. */
export function __resetCanvasGlobalBrandBreathSessionForTests(): void {
  shown = false
}
